import { Link } from "react-router-dom";
import styled from "styled-components";
import SetSeoMeta from "../components/Seo/Seo";

export default function ErrorPageNotFound() {
  return (
    <>
      <SetSeoMeta
        title='1731 - Error 404'
        description='Page not found'
        name='Totengilde Blekendorf von 1731'
        type='article'
      />
      <BackgroundDiv>
        <div
          style={{
            margin: "auto",
            alignSelf: "center",
            paddingTop: "20%",
            textAlign: "center",
            fontSize: "2rem",
            color: "black",
            // border: "3px solid violet",
          }}
        >
          <h1 style={{ textAlign: "center", color: "#052186" }}>
            Totengilde Blekendorf von 1731
          </h1>
          <img
            src="images/GildeBlekendorf-von-KO.jpg"
            alt="Wappen Totengilde Blekendorf von 1731"
            width="110rem"
            height="100rem"
          />

          {""}
          <p>404 Seite nicht gefunden</p>
          <p>404 page not found</p>
          <Link to="/">
            <p>Bring mich zurück zur Startseite!</p>
            <p>Take me back to the main page!</p>
          </Link>
        </div>
      </BackgroundDiv>
    </>
  );
}

const BackgroundDiv = styled.div`
  /* background-image: url("images/GildeBlekendorf-von-KO.jpg") !important; */
  /* background-image: url("images/plan3.jpg") !important; */
  /* background-repeat: no-repeat; */
  background-attachment: fixed;
  /* background-position: 70%; */
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  position: relative;
  // background-position-x: center;
  min-height: 100vh;
  max-height: 100%;
  /* @media only screen and (max-width: 800px) {
    background-image: url("images/plan.jpg");
  }; */
`;
